import { themeAtom } from "../../shared/atoms";
import type { Tq1InputCellProps, Tq1LabelCellProps } from "../models/tech-form-page.models";
import { useAtomValue } from "jotai";
import { twMerge } from "tailwind-merge";

export const HeaderCell = ({ label, width }: Tq1LabelCellProps) => (
  <div style={{ width }}>
    <p className="font-bold">{label}</p>
  </div>
);

export const LabelCell = ({ label, width }: Tq1LabelCellProps) => (
  <div style={{ width }} className="font-medium">
    {label}
  </div>
);

export const InputCell = ({
  value,
  name,
  error,
  onChange,
  width,
  trailingText,
  inputType = "text",
  inputMode,
}: Tq1InputCellProps) => {
  const theme = useAtomValue(themeAtom);

  return (
    <div style={{ width }}>
      <div className="flex items-center">
        <input
          name={name}
          aria-invalid={Boolean(error)}
          aria-describedby={error && name ? name + "-error" : undefined}
          type={inputType}
          inputMode={inputMode}
          value={value}
          onChange={onChange}
          className={twMerge(
            "w-full border px-2 py-3.5 focus:outline-none",
            trailingText ? "rounded-s-md" : "rounded-md",
            error ? "border-red-600" : theme.uwhcAssistant.border,
          )}
        />
        {trailingText && (
          <span
            className={twMerge(
              "min-w-14 rounded-e-md border border-l-0 px-2 py-3.5 text-center",
              theme.uwhcAssistant.border,
              theme.balticQuestionnaire.grayBg,
            )}
          >
            {trailingText}
          </span>
        )}
      </div>
      {error && (
        <p id={name ? name + "-error" : undefined} className="mt-1 text-xs text-red-600">
          {error}
        </p>
      )}
    </div>
  );
};
